import { useState } from 'react';
import { DollarSign, Settings, Users, FileText, Calculator, Archive } from 'lucide-react';
import TarifarioTab from './TarifarioTab';
import AnunciantesTab from './AnunciantesTab';
import PautasTab from './PautasTab';
import CotizadorTab from './CotizadorTab';
import BibliotecaTab from './BibliotecaTab';
import styles from './PublicidadTab.module.css';

const SUBTABS = [
  { id: 'tarifario',   label: 'Tarifario',              icon: Settings   },
  { id: 'anunciantes', label: 'Anunciantes',            icon: Users      },
  { id: 'pautas',      label: 'Pautas',                 icon: FileText   },
  { id: 'cotizador',   label: 'Cotizador',              icon: Calculator },
  { id: 'biblioteca',  label: 'Biblioteca de materiales', icon: Archive  },
];

export default function PublicidadTab() {
  const [sub, setSub] = useState('tarifario');

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <DollarSign size={20} className={styles.headerIcon} />
        <h2 className={styles.headerTitle}>Módulo de Publicidad</h2>
      </div>

      <div className={styles.subtabBar}>
        {SUBTABS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            className={`${styles.subtab} ${sub === id ? styles.subtabActive : ''}`}
            onClick={() => setSub(id)}
          >
            <Icon size={15} />
            {label}
          </button>
        ))}
      </div>

      <div className={styles.content}>
        {sub === 'tarifario'   && <TarifarioTab />}
        {sub === 'anunciantes' && <AnunciantesTab />}
        {sub === 'pautas'      && <PautasTab />}
        {sub === 'cotizador'   && <CotizadorTab />}
        {sub === 'biblioteca'  && <BibliotecaTab />}
      </div>
    </div>
  );
}
